import { SelectOptionType } from "types"

export const FILTER_BUGET_MANAGER_DATA: SelectOptionType[] = [
  { value: "0", label: "All" },
  { value: "04", label: "Income" },
  { value: "05", label: "Cost Of Goods" },
  { value: "06", label: "Expences" },
  { value: "08", label: "Other Income" },
  { value: "09", label: "Other Expences" }
]
